import * as yup from 'yup'
import useTrans from '../../../hooks/useTrans'
import { useSelector } from 'react-redux'
import { isRequiredField } from '../../../utils/servicegift'

export function getValidationSchema(tipologiaUtenteChiave, isMerceNeutra, guest) {
  const t = useTrans()
  const service_gift = useSelector((state) => state?.servicegift?.service_gift)

  const withRequired = (chiave, yupObject) => {
    if (isRequiredField(service_gift, tipologiaUtenteChiave, 'checkout', chiave)) {
      return yupObject?.type == 'boolean'
        ? yupObject.oneOf([true])
        : yupObject.required(t('Questo campo è obbligatorio')).nullable()
    }

    return yupObject.nullable()
  }

  const indirizzoValidationSchema = (chiavePrefix) => {
    return yup
      .object({
        nome: withRequired(`${chiavePrefix}.nome`, yup.string()),
        cognome: withRequired(`${chiavePrefix}.cognome`, yup.string()),
        ragione_sociale: withRequired(`${chiavePrefix}.ragione_sociale`, yup.string()),
        email: withRequired(
          `${chiavePrefix}.email`,
          yup.string().email(t("L'email deve essere valida"))
        ),
        telefono: withRequired(
          `${chiavePrefix}.telefono`,
          yup.string().min(8, t('Minimo {0} caratteri', [8]))
        ),
        partita_iva: withRequired(
          `${chiavePrefix}.partita_iva`,
          yup.string().max(11, t('Massimo {0} caratteri', [11]))
        ),
        indirizzo: withRequired(
          `${chiavePrefix}.indirizzo`,
          yup.string().max(35, t('Troppo lungo'))
        ),
        cap: withRequired(
          `${chiavePrefix}.cap`,
          yup.string().min(5, t('Minimo {0} caratteri', [5]))
        ),
        citta: withRequired(`${chiavePrefix}.citta`, yup.string()),
        nazione_id: withRequired(`${chiavePrefix}.nazione`, yup.string()),
        provincia: yup
          .string()
          .when('is_italia', {
            is: true,
            then: withRequired(`${chiavePrefix}.provincia`, yup.string()),
          })
          .nullable(),
        cod_fiscale: withRequired(`${chiavePrefix}.cod_fiscale`, yup.string()),
        sdi: yup
          .string()
          .when('is_italia', {
            is: true,
            then: withRequired(`${chiavePrefix}.sdi`, yup.string()),
          })
          .nullable(),
        pec: yup
          .string()
          .when('is_italia', {
            is: true,
            then: withRequired(
              `${chiavePrefix}.pec`,
              yup.string().email(t('La pec deve essere valida'))
            ),
          })
          .nullable(),
      })
      .nullable()
  }

  return isMerceNeutra
    ? yup.object({
        tipo_spedizione: yup.string().required(),
        indirizzo: guest
          ? yup.object().nullable()
          : indirizzoValidationSchema('indirizzo_spedizione'),
        indirizzo_fatturazione: guest
          ? yup.object().nullable()
          : indirizzoValidationSchema('indirizzo_fatturazione'),
        id_modalita_pagamento: yup.number(),
        note_ordine: withRequired('checkout.note_ordine', yup.string()),
        with_registrazione: yup.boolean(),
        autorizzazioni: yup.object({
          privacy_commerciale: withRequired('utente.autorizzazioni_consensi', yup.bool()),
        }),
        utente: guest
          ? yup.object().when('with_registrazione', {
              is: true,
              then: yup
                .object({
                  nome: withRequired('utente.nome', yup.string()),
                  cognome: withRequired('utente.cognome', yup.string()),
                  // email: withRequired('utente.email', yup.string().email(t("L'email deve essere valida"))),
                  telefono: withRequired(
                    'utente.telefono',
                    yup.string().min(8, t('Minimo {0} caratteri', [8]))
                  ),
                  // cod_fiscale: withRequired('utente.cod_fiscale', yup.string()),
                  username: yup
                    .string()
                    .email("L'email deve essere valida")
                    .required(t('Questo campo è obbligatorio'))
                    .nullable(),
                  password: yup
                    .string()
                    .label('Password')
                    .required(t('Questo campo è obbligatorio'))
                    .min(6, t('Minimo {0} caratteri', [6]))
                    .nullable(),
                  conferma_password: yup
                    .string()
                    .required(t('Questo campo è obbligatorio'))
                    .label(t('Conferma Password'))
                    .test('passwords-match', t('Le due password dovrebbero coincidere'), function (
                      value
                    ) {
                      return this.parent.password === value
                    })
                    .nullable(),
                })
                .required(),
              otherwise: yup
                .object({
                  nome: withRequired('utente.nome', yup.string()),
                  cognome: withRequired('utente.cognome', yup.string()),
                  // email: withRequired('utente.email', yup.string().email(t("L'email deve essere valida"))),
                  telefono: withRequired(
                    'utente.telefono',
                    yup.string().min(8, t('Minimo {0} caratteri', [8]))
                  ),
                  // cod_fiscale: withRequired('utente.cod_fiscale', yup.string()),
                  username: yup
                    .string()
                    .email("L'email deve essere valida")
                    .required(t('Questo campo è obbligatorio'))
                    .nullable(),
                  password: yup.string().label('Password').nullable(),
                  conferma_password: yup.string().label(t('Conferma Password')).nullable(),
                })
                .required(),
            })
          : yup.object().nullable(),
        dati_indirizzo: guest
          ? yup.object().when('indirizzi_diversi', {
              is: true,
              then: yup.object().when('is_fatturazione_italia', {
                is: true,
                then: yup.object({
                  nome: withRequired('indirizzo_fatturazione.nome', yup.string()),
                  cognome: withRequired('indirizzo_fatturazione.cognome', yup.string()),
                  ragione_sociale: withRequired(
                    'indirizzo_fatturazione.ragione_sociale',
                    yup.string()
                  ),
                  email: withRequired(
                    'indirizzo_fatturazione.email',
                    yup.string().email(t("L'email deve essere valida"))
                  ),
                  telefono: withRequired(
                    'indirizzo_fatturazione.telefono',
                    yup.string().min(8, t('Minimo {0} caratteri', [8]))
                  ),
                  partita_iva: withRequired(
                    'indirizzo_fatturazione.partita_iva',
                    yup.string().max(11, t('Massimo {0} caratteri', [11]))
                  ),
                  indirizzo: withRequired(
                    'indirizzo_fatturazione.indirizzo',
                    yup.string().max(35, t('Troppo lungo'))
                  ),
                  cap: withRequired(
                    'indirizzo_fatturazione.cap',
                    yup.string().min(5, t('Minimo {0} caratteri', [5]))
                  ),
                  citta: withRequired('indirizzo_fatturazione.citta', yup.string()),
                  nazione_id: withRequired('indirizzo_fatturazione.nazione', yup.string()),
                  provincia: withRequired('indirizzo_fatturazione.provincia', yup.string()),
                  cod_fiscale: withRequired('indirizzo_fatturazione.cod_fiscale', yup.string()),
                  sdi: withRequired('indirizzo_fatturazione.sdi', yup.string()),
                  pec: withRequired(
                    'indirizzo_fatturazione.pec',
                    yup.string().email(t('La pec deve essere valida'))
                  ),
                }),
                otherwise: yup.object({
                  nome: withRequired('indirizzo_fatturazione.nome', yup.string()),
                  cognome: withRequired('indirizzo_fatturazione.cognome', yup.string()),
                  ragione_sociale: withRequired(
                    'indirizzo_fatturazione.ragione_sociale',
                    yup.string()
                  ),
                  email: withRequired(
                    'indirizzo_fatturazione.email',
                    yup.string().email(t("L'email deve essere valida"))
                  ),
                  telefono: withRequired(
                    'indirizzo_fatturazione.telefono',
                    yup.string().min(8, t('Minimo {0} caratteri', [8]))
                  ),
                  partita_iva: withRequired(
                    'indirizzo_fatturazione.partita_iva',
                    yup.string().max(11, t('Massimo {0} caratteri', [11]))
                  ),
                  indirizzo: withRequired(
                    'indirizzo_fatturazione.indirizzo',
                    yup.string().max(35, t('Troppo lungo'))
                  ),
                  cap: withRequired(
                    'indirizzo_fatturazione.cap',
                    yup.string().min(5, t('Minimo {0} caratteri', [5]))
                  ),
                  citta: withRequired('indirizzo_fatturazione.citta', yup.string()),
                  nazione_id: withRequired('indirizzo_fatturazione.nazione', yup.string()),
                  provincia: yup.string().nullable(),
                  cod_fiscale: withRequired('indirizzo_fatturazione.cod_fiscale', yup.string()),
                  sdi: yup.string().nullable(),
                  pec: yup.string().email(t('La pec deve essere valida')).nullable(),
                }),
              }),
              otherwise: yup.object().nullable(),
            })
          : yup.object().nullable(),
        dati_indirizzo_spedizione: guest
          ? yup.object().when('is_spedizione_italia', {
              is: true,
              then: yup.object({
                nome: withRequired('indirizzo_spedizione.nome', yup.string()),
                cognome: withRequired('indirizzo_spedizione.cognome', yup.string()),
                ragione_sociale: withRequired('indirizzo_spedizione.ragione_sociale', yup.string()),
                email: withRequired(
                  'indirizzo_spedizione.email',
                  yup.string().email(t("L'email deve essere valida"))
                ),
                telefono: withRequired(
                  'indirizzo_spedizione.telefono',
                  yup.string().min(8, t('Minimo {0} caratteri', [8]))
                ),
                partita_iva: withRequired(
                  'indirizzo_spedizione.partita_iva',
                  yup.string().max(11, t('Massimo {0} caratteri', [11]))
                ),
                indirizzo: withRequired(
                  'indirizzo_spedizione.indirizzo',
                  yup.string().max(35, t('Troppo lungo'))
                ),
                cap: withRequired(
                  'indirizzo_spedizione.cap',
                  yup.string().min(5, t('Minimo {0} caratteri', [5]))
                ),
                citta: withRequired('indirizzo_spedizione.citta', yup.string()),
                nazione_id: withRequired('indirizzo_spedizione.nazione', yup.string()),
                provincia: withRequired('indirizzo_spedizione.provincia', yup.string()),
                cod_fiscale: withRequired('indirizzo_spedizione.cod_fiscale', yup.string()),
                sdi: withRequired('indirizzo_spedizione.sdi', yup.string()),
                pec: withRequired(
                  'indirizzo_spedizione.pec',
                  yup.string().email(t('La pec deve essere valida'))
                ),
              }),
              otherwise: yup.object({
                nome: withRequired('indirizzo_spedizione.nome', yup.string()),
                cognome: withRequired('indirizzo_spedizione.cognome', yup.string()),
                ragione_sociale: withRequired('indirizzo_spedizione.ragione_sociale', yup.string()),
                email: withRequired(
                  'indirizzo_spedizione.email',
                  yup.string().email(t("L'email deve essere valida"))
                ),
                telefono: withRequired(
                  'indirizzo_spedizione.telefono',
                  yup.string().min(8, t('Minimo {0} caratteri', [8]))
                ),
                partita_iva: withRequired(
                  'indirizzo_spedizione.partita_iva',
                  yup.string().max(11, t('Massimo {0} caratteri', [11]))
                ),
                indirizzo: withRequired(
                  'indirizzo_spedizione.indirizzo',
                  yup.string().max(35, t('Troppo lungo'))
                ),
                cap: withRequired(
                  'indirizzo_spedizione.cap',
                  yup.string().min(5, t('Minimo {0} caratteri', [5]))
                ),
                citta: withRequired('indirizzo_spedizione.citta', yup.string()),
                nazione_id: withRequired('indirizzo_spedizione.nazione', yup.string()),
                provincia: yup.string().nullable(),
                cod_fiscale: withRequired('indirizzo_spedizione.cod_fiscale', yup.string()),
                sdi: yup.string().nullable(),
                pec: yup.string().email(t('La pec deve essere valida')).nullable(),
              }),
            })
          : yup.object().nullable(),
      })
    : yup.object({
        tipo_spedizione: yup.string().required(),
        indirizzo: guest
          ? yup.object().nullable()
          : indirizzoValidationSchema('indirizzo_spedizione'),
        indirizzo_fatturazione: guest
          ? yup.object().nullable()
          : indirizzoValidationSchema('indirizzo_fatturazione'),
        email_bozza_digitale_diversa: yup.boolean(),
        email_bozza_digitale: yup.string().when('email_bozza_digitale_diversa', {
          is: true,
          then: yup
            .string()
            .email('Il formato inserito non corrisponde ad una e-mail')
            .required(t('Questo campo è obbligatorio'))
            .nullable(),
          otherwise: yup.string().nullable(),
        }),
        id_modalita_pagamento: yup.number(),
        note_ordine: withRequired('checkout.note_ordine', yup.string()),
        with_registrazione: yup.boolean(),
        autorizzazioni: yup.object({
          privacy_commerciale: withRequired('utente.autorizzazioni_consensi', yup.bool()),
        }),
        utente: guest
          ? yup.object().when('with_registrazione', {
              is: true,
              then: yup
                .object({
                  nome: withRequired('utente.nome', yup.string()),
                  cognome: withRequired('utente.cognome', yup.string()),
                  // email: withRequired('utente.email', yup.string().email(t("L'email deve essere valida"))),
                  telefono: withRequired(
                    'utente.telefono',
                    yup.string().min(8, t('Minimo {0} caratteri', [8]))
                  ),
                  // cod_fiscale: withRequired('utente.cod_fiscale', yup.string()),
                  username: yup
                    .string()
                    .email("L'email deve essere valida")
                    .required(t('Questo campo è obbligatorio'))
                    .nullable(),
                  password: yup
                    .string()
                    .label('Password')
                    .required(t('Questo campo è obbligatorio'))
                    .min(6, t('Minimo {0} caratteri', [6]))
                    .nullable(),
                  conferma_password: yup
                    .string()
                    .required(t('Questo campo è obbligatorio'))
                    .label(t('Conferma Password'))
                    .test('passwords-match', t('Le due password dovrebbero coincidere'), function (
                      value
                    ) {
                      return this.parent.password === value
                    })
                    .nullable(),
                })
                .required(),
              otherwise: yup
                .object({
                  nome: withRequired('utente.nome', yup.string()),
                  cognome: withRequired('utente.cognome', yup.string()),
                  // email: withRequired('utente.email', yup.string().email(t("L'email deve essere valida"))),
                  telefono: withRequired(
                    'utente.telefono',
                    yup.string().min(8, t('Minimo {0} caratteri', [8]))
                  ),
                  // cod_fiscale: withRequired('utente.cod_fiscale', yup.string()),
                  username: yup
                    .string()
                    .email("L'email deve essere valida")
                    .required(t('Questo campo è obbligatorio'))
                    .nullable(),
                  password: yup.string().label('Password').nullable(),
                  conferma_password: yup.string().label(t('Conferma Password')).nullable(),
                })
                .required(),
            })
          : yup.object().nullable(),
        dati_indirizzo: guest
          ? yup.object().when('indirizzi_diversi', {
              is: true,
              then: yup.object().when('is_fatturazione_italia', {
                is: true,
                then: yup.object({
                  nome: withRequired('indirizzo_fatturazione.nome', yup.string()),
                  cognome: withRequired('indirizzo_fatturazione.cognome', yup.string()),
                  ragione_sociale: withRequired(
                    'indirizzo_fatturazione.ragione_sociale',
                    yup.string()
                  ),
                  email: withRequired(
                    'indirizzo_fatturazione.email',
                    yup.string().email(t("L'email deve essere valida"))
                  ),
                  telefono: withRequired(
                    'indirizzo_fatturazione.telefono',
                    yup.string().min(8, t('Minimo {0} caratteri', [8]))
                  ),
                  partita_iva: withRequired(
                    'indirizzo_fatturazione.partita_iva',
                    yup.string().max(11, t('Massimo {0} caratteri', [11]))
                  ),
                  indirizzo: withRequired(
                    'indirizzo_fatturazione.indirizzo',
                    yup.string().max(35, t('Troppo lungo'))
                  ),
                  cap: withRequired(
                    'indirizzo_fatturazione.cap',
                    yup.string().min(5, t('Minimo {0} caratteri', [5]))
                  ),
                  citta: withRequired('indirizzo_fatturazione.citta', yup.string()),
                  nazione_id: withRequired('indirizzo_fatturazione.nazione', yup.string()),
                  provincia: withRequired('indirizzo_fatturazione.provincia', yup.string()),
                  cod_fiscale: withRequired('indirizzo_fatturazione.cod_fiscale', yup.string()),
                  sdi: withRequired('indirizzo_fatturazione.sdi', yup.string()),
                  pec: withRequired(
                    'indirizzo_fatturazione.pec',
                    yup.string().email(t('La pec deve essere valida'))
                  ),
                }),
                otherwise: yup.object({
                  nome: withRequired('indirizzo_fatturazione.nome', yup.string()),
                  cognome: withRequired('indirizzo_fatturazione.cognome', yup.string()),
                  ragione_sociale: withRequired(
                    'indirizzo_fatturazione.ragione_sociale',
                    yup.string()
                  ),
                  email: withRequired(
                    'indirizzo_fatturazione.email',
                    yup.string().email(t("L'email deve essere valida"))
                  ),
                  telefono: withRequired(
                    'indirizzo_fatturazione.telefono',
                    yup.string().min(8, t('Minimo {0} caratteri', [8]))
                  ),
                  partita_iva: withRequired(
                    'indirizzo_fatturazione.partita_iva',
                    yup.string().max(11, t('Massimo {0} caratteri', [11]))
                  ),
                  indirizzo: withRequired(
                    'indirizzo_fatturazione.indirizzo',
                    yup.string().max(35, t('Troppo lungo'))
                  ),
                  cap: withRequired(
                    'indirizzo_fatturazione.cap',
                    yup.string().min(5, t('Minimo {0} caratteri', [5]))
                  ),
                  citta: withRequired('indirizzo_fatturazione.citta', yup.string()),
                  nazione_id: withRequired('indirizzo_fatturazione.nazione', yup.string()),
                  provincia: yup.string().nullable(),
                  cod_fiscale: withRequired('indirizzo_fatturazione.cod_fiscale', yup.string()),
                  sdi: yup.string().nullable(),
                  pec: yup.string().email(t('La pec deve essere valida')).nullable(),
                }),
              }),
              otherwise: yup.object().nullable(),
            })
          : yup.object().nullable(),
        dati_indirizzo_spedizione: guest
          ? yup.object().when('is_spedizione_italia', {
              is: true,
              then: yup.object({
                nome: withRequired('indirizzo_spedizione.nome', yup.string()),
                cognome: withRequired('indirizzo_spedizione.cognome', yup.string()),
                ragione_sociale: withRequired('indirizzo_spedizione.ragione_sociale', yup.string()),
                email: withRequired(
                  'indirizzo_spedizione.email',
                  yup.string().email(t("L'email deve essere valida"))
                ),
                telefono: withRequired(
                  'indirizzo_spedizione.telefono',
                  yup.string().min(8, t('Minimo {0} caratteri', [8]))
                ),
                partita_iva: withRequired(
                  'indirizzo_spedizione.partita_iva',
                  yup.string().max(11, t('Massimo {0} caratteri', [11]))
                ),
                indirizzo: withRequired(
                  'indirizzo_spedizione.indirizzo',
                  yup.string().max(35, t('Troppo lungo'))
                ),
                cap: withRequired(
                  'indirizzo_spedizione.cap',
                  yup.string().min(5, t('Minimo {0} caratteri', [5]))
                ),
                citta: withRequired('indirizzo_spedizione.citta', yup.string()),
                nazione_id: withRequired('indirizzo_spedizione.nazione', yup.string()),
                provincia: withRequired('indirizzo_spedizione.provincia', yup.string()),
                cod_fiscale: withRequired('indirizzo_spedizione.cod_fiscale', yup.string()),
                sdi: withRequired('indirizzo_spedizione.sdi', yup.string()),
                pec: withRequired(
                  'indirizzo_spedizione.pec',
                  yup.string().email(t('La pec deve essere valida'))
                ),
              }),
              otherwise: yup.object({
                nome: withRequired('indirizzo_spedizione.nome', yup.string()),
                cognome: withRequired('indirizzo_spedizione.cognome', yup.string()),
                ragione_sociale: withRequired('indirizzo_spedizione.ragione_sociale', yup.string()),
                email: withRequired(
                  'indirizzo_spedizione.email',
                  yup.string().email(t("L'email deve essere valida"))
                ),
                telefono: withRequired(
                  'indirizzo_spedizione.telefono',
                  yup.string().min(8, t('Minimo {0} caratteri', [8]))
                ),
                partita_iva: withRequired(
                  'indirizzo_spedizione.partita_iva',
                  yup.string().max(11, t('Massimo {0} caratteri', [11]))
                ),
                indirizzo: withRequired(
                  'indirizzo_spedizione.indirizzo',
                  yup.string().max(35, t('Troppo lungo'))
                ),
                cap: withRequired(
                  'indirizzo_spedizione.cap',
                  yup.string().min(5, t('Minimo {0} caratteri', [5]))
                ),
                citta: withRequired('indirizzo_spedizione.citta', yup.string()),
                nazione_id: withRequired('indirizzo_spedizione.nazione', yup.string()),
                provincia: yup.string().nullable(),
                cod_fiscale: withRequired('indirizzo_spedizione.cod_fiscale', yup.string()),
                sdi: yup.string().nullable(),
                pec: yup.string().email(t('La pec deve essere valida')).nullable(),
              }),
            })
          : yup.object().nullable(),
      })
}
